import { useQuery } from '@tanstack/react-query';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';

export const notificationsKeys = {
  all: ['notifications'],
  notifications: () => [...notificationsKeys.all],
  notification: (id) => [...notificationsKeys.notifications(), id]
};

export const useNotifications = () => {
  const api = useAPI();
  const notificationsQuery = useQuery({
    queryKey: notificationsKeys.notifications(),
    queryFn: createQueryRequest(api.core.getNotifications),
    initialData: [],
    retry: 1
  });
  return { notificationsQuery, notifications: notificationsQuery.data ?? [], isLoading: notificationsQuery.isLoading };
};

export const useNotification = (id) => {
  const api = useAPI();
  const notificationQuery = useQuery({
    queryKey: notificationsKeys.notification(id),
    queryFn: createQueryRequest(api.core.getNotification, id),
    enabled: !!id
  });
  return { notificationQuery, notification: notificationQuery.data, isLoading: id ? notificationQuery.isLoading : false };
};
